<div class="ledger-container ">
    <!-- <div class="tab-nav d-flex align-item-center justify-content-between">
        <ul class="list-inline list-unstyled p-0 m-0">
            <li class="active page-title   text-uppercase"> Flown Report</li>
        </ul>
        <ul class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0">
            <li [routerLink]="['/']" class="text-grey text-capitalize cursor  hover-text-primary transition"> Dashboard
            </li>
            <li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg" alt=""></li>
            <li class="text-grey text-capitalize cursor text-primary transition">View Flown Report</li>
        </ul>
    </div> -->
    <div class="row tab-nav pl-0 pr-0 justify-content-between">
        <!-- <div class="col-sm-4 pl-0">
                      <ul class="list-inline list-unstyled p-0 m-0">
                          <li class="active page-title text-uppercase cursor"> View Client</li>
                      </ul>
                  </div> -->
                  <div *ngIf="showMessage" class="status-modal-box  transition delay scale-1" [ngClass]="{'show-modal-box': showMessage, 'hide-modal-box': !showMessage}">
			<div class="status-card transition w-100per position-fixed top-10 bg-white-color modal-box-card d-flex flex-y-center w-100per justify-space-between p-10-20 bdr-radius-10 mb-10">
			  <div class="d-flex flex-y-center">
				<img
				  src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/{{alertType=='error-box' ? 'red-circle-error.svg' :
					alertType=='success-box' ? 'green-sucess.svg' : 
					alertType=='warning-box' ? 'red-warning.svg' : 
					null }}"
				  width="20px"
				  height="20px"
				  alt="alert-logo"
				  class="mr-20"
				/>
				<div class="ml-10">
				  <h4 class="m-0 text-size-18 text-bold"
				  [ngClass]="{'text-red': alertType=='error-box', 'text-orange-color': alertType=='warning-box', 'text-green' :  alertType=='success-box' }">
					{{alertType === "error-box"
					? "Error"
					: alertType === "warning-box"
					? "Warning"
					: alertType === "success-box"
					? "Success"
					: null}}
				  </h4>
				  <small className="text-dark-grey-color text-size-12 mt-5 mb-0">
				   {{message}}
				  </small>
				</div>
			  </div>
			  <img
				src="{{commonService.aws_asset_url}}/_assets/icons/red-close.svg"
				alt="close-btn"
				(click)="hideError()"
				className=" close-btn"
			  />
			</div>
		  </div>
        <div class="col-sm-4">
          <ul
            class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0"
          >
            <li
              [routerLink]="['/']"
              class="text-grey text-capitalize cursor hover-text-primary transition"
            >
              Analysis
            </li>
            <li>
              <img
                src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg"
                alt=""
              />
            </li>
            <li
              class="text-grey text-capitalize cursor text-primary transition"
            >
            Custom Report
            </li>
            <!-- <li class="text-primary line-clamp line-clamp-1">
              <ng-container
                *ngFor="let data of leaderData['all_clients_records']"
              >
                <span class="text-bold">
                  {{ data["display_name"] }}
                </span>
              </ng-container>
            </li> -->
          </ul>
        </div>
        <!-- <div class="col-sm-4 text-center">
          <span class="rec-date d-block text-center">
            <div class="noWrap justify-content-around">
              <ng-container>
                <div class="cname text-bold">
                  <span class="text-bold"
                    >From </span
                  >
                  <h5 style="margin-right: 5px" class="mb-0 d-inline">
                    <span
                      class="date text-bold text-orange"
                    >{{duration && duration.from}}
                    </span>
                    <span class="date text-bold" >
                      To
                    </span>
                    <span class="date text-bold text-orange">
                      {{duration && duration.to}}
                    </span>
                  </h5>
                 
                  <button
                    [ngClass]="{ 'd-none': isPrint == 'true' }"
                    title="Custom Search"
                    class="btn save-as text-bold bg-whiteSmoke"
                    type="button" (click)="openAdvanceSearchModal()"
                  >
                    <img
                      src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/green-edit.svg"
                      alt=""
                      width="15px"
                    />
                  </button>
                </div>
              </ng-container>
            </div>
          </span>
        </div> -->
      </div>
      <div class="flexbox ">
          <div class="text-input-field">
             <button *ngIf="BranchAccess==true" id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" 
              searchtabindex="3"[disabled]="misReportFilterForm.invalid"
              (click)="search(misReportFilterForm.value)">
              Get Branch Report </button>
              <button *ngIf="ConsolidateAccess==true"  id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" 
              searchtabindex="3"[disabled]="misReportFilterForm.invalid"
              (click)="searchCOnsolidate()">
              Get Consolidate report</button>
            
			<button *ngIf="BranchAccess==true"  type="button" class="btn-style bg-green ml-3" (click)="openInNewTab()">
            Open Branch Report in New Tab
          </button>
          <button *ngIf="ConsolidateAccess==true" type="button" class="btn-style bg-green ml-3" (click)="openConsolidateInNewTab()">
            Open Consolidate Report in New Tab
          </button>
              </div>
        </div>
        <div class="flexbox ">
          <div class="text-input-field">
        <button  type="button" class="btn-style bg-orange ml-3" (click)="updateRealTime()">
            Sync Now
          </button>
           </div>
        </div>
  </div>
  

  <div *ngIf="showIframe" class="mt-3" style="height:80vh;">
  <iframe
    [src]="safeSheetUrl"
    width="100%"
    height="100%"
    style="border:none;"
    loading="lazy"
    referrerpolicy="no-referrer">
  </iframe>
</div>